import { useMutation } from '@tanstack/react-query';
import { UpdateFreeChatLimit, UpdateVersion, UpdateSettingsDetails } from '../../../../Api/setting';
import { UpdateUserMessage } from '../../../../Api/setting';

export const useMutateUpdateVersion = () =>
  useMutation({
    mutationFn: (data) => UpdateVersion(data),
  });

export const useMutateUpdateUserMessage = () =>
  useMutation({
    mutationFn: (data) => UpdateUserMessage(data),
  });

export const useMutateUpdateFreeChatLimit = () =>
  useMutation({
    mutationFn: (data) => UpdateFreeChatLimit(data),
  });

export const useMutateUpdateSettingsDetails = () =>
  useMutation({
    mutationFn: (data) => UpdateSettingsDetails(data),
  });

